import { connect, loadDesignSystem } from 'q2-tecton-sdk';
import { init } from 'q2-tecton-platform';
import { ITectonPlatformControls } from 'q2-tecton-platform/dist/esm/setup';
import { ActionSheetData, showActionSheet } from 'q2-tecton-common/lib/utility/action-sheet';

export async function initializeDesignSystem() {
    const result = await loadDesignSystem();
    (window as TectonWindow).tecton = result;
}

export async function initializeSDK() {
    const result = await connect({
        legacy: window.parent === window,
        loadDefaultTheme: true,
        loadUtilities: true,
    });
    (window as TectonWindow).tecton = result;
}

export function initializePlatform() {
    const configFixture = {
        features: {},
    };

    const stubbedAdaptor = {
        closeOverpanel() {},
        setOverpanelTitle() {},
        showModal(options: { message: string }) {
            alert(options.message);
        },
        showActionSheet: (data: ActionSheetData) => {
            return showActionSheet(data);
        },
        navigateTo() {},
        sendRequest() {},
        accessConfig() {},
        updateParams() {},
        clearParams() {},
        getCurrentTheme() {
            return 'theme-q2';
        },
        getCurrentLanguage() {},
        notificationCenter: {
            on() {},
            off() {},
            trigger() {},
        },
        getCustomerSpecificAssetPath(subPath: string) {
            if (window.location.href.includes('devcdn')) {
                return 'http://devcdn/cdn/0001/100.0.0.0/0000/assets/' + subPath;
            }
            return 'https://cdn1.onlineaccess1.com/cdn/base/4.4.0.130/assets/' + subPath;
        },
        getBaseAssetPath(subPath: string) {
            if (window.location.href.includes('devcdn')) {
                return 'http://devcdn/cdn/base/100.0.0.0/assets/' + subPath;
            }
            return 'https://cdn1.onlineaccess1.com/cdn/base/4.4.0.130/assets/' + subPath;
        },
        getVersionInfo() {
            return { PLATFORM_VERSION: '', FI_IDENTIFIER: '', useActionSheets: false };
        },
    } as unknown as ITectonPlatformControls;

    if (window.parent !== window) return;
    init(configFixture, stubbedAdaptor);
}

export function initializePendo() {
    const apiKey = 'ced8bd54-1203-4e91-7807-dec9519d09a6';
    const deferredOptions = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
    const tectonWindow = window as TectonWindow;

    let pendoObject = (tectonWindow['pendo'] = tectonWindow['pendo'] || {});
    pendoObject._q = [];

    const deferredOptionsLength = deferredOptions.length;
    for (let i = 0; i < deferredOptionsLength; ++i) {
        const deferredOption = deferredOptions[i];
        pendoObject[deferredOption] =
            pendoObject[deferredOption] ||
            function () {
                pendoObject._q[deferredOption === deferredOptions[0] ? 'unshift' : 'push'](
                    [deferredOption].concat([].slice.call(arguments, 0))
                );
            };
    }

    const pendoScript = document.createElement('script');
    pendoScript.async = !0;
    pendoScript.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;

    const appendPoint = document.getElementsByTagName('script')[0];
    appendPoint.parentNode?.insertBefore(pendoScript, appendPoint);

    let sdkVersion = (window as TectonWindow).Tecton.TECTON_SDK_VERSION;
    if (window.location.href.indexOf('develop') > -1 || window.location.href.indexOf('localhost') > -1) {
        sdkVersion = 'develop';
    } else if (!sdkVersion && window.location.href.indexOf('/v') > -1) {
        sdkVersion = window.location.href.split('/v')[1].split('/')[0];
    }

    tectonWindow.pendo.initialize({
        apiKey: apiKey,
        account: {
            version: sdkVersion,
        },
    });
}
